import { render, staticRenderFns } from "./CPTemp10.vue?vue&type=template&id=8f4a7c42&scoped=true&"
import script from "./CPTemp10.vue?vue&type=script&lang=js&"
export * from "./CPTemp10.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp10.vue?vue&type=style&index=0&id=8f4a7c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4a7c42",
  null
  
)

export default component.exports